// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ET9hu","requiredAsterisk":"Info_requiredAsterisk__G43v_"};